import React, { useState } from "react";
import classes from "./andMarketPlace.module.css";

// Components
import ArtworkCard from "./ArtworkCard";
import FilterSidebar from "./FilterSidebar";
import {
  ARTIST_1,
  ARTIST_2,
  ARTIST_3,
  ARTIST_4,
  ARTIST_5,
} from "../../utils/images";
import Footer from "../../components/footer";

const ANDMarketPlace = () => {
  // State for filters
  const [priceRange, setPriceRange] = useState([1000, 2000]);
  const [minPrice, setMinPrice] = useState("1000");
  const [maxPrice, setMaxPrice] = useState("2000");
  const [selectedCollection, setSelectedCollection] = useState("Fantasy");
  const [selectedMedium, setSelectedMedium] = useState("Any");
  const [searchQuery, setSearchQuery] = useState("");
  const [location, setLocation] = useState("");
  const [activeFilters, setActiveFilters] = useState([
    { type: "price", value: "$1000-$2000" },
    { type: "collection", value: "Fantasy" },
  ]);

  // Sample artwork data
  const artworks = [
    {
      id: 1,
      title: "Me And My Husband",
      artist: "Olha A",
      price: 800,
      currency: "$",
      rating: 5.0,
      image: ARTIST_1,
      collection: "Fantasy",
    },
    {
      id: 2,
      title: "Lion Spirit",
      artist: "Jayna S",
      price: 1600,
      currency: "$",
      rating: 4.9,
      image: ARTIST_2,
      collection: "Animals",
    },
    {
      id: 3,
      title: "Body Bolide",
      artist: "Sasha T",
      price: 900,
      currency: "$",
      rating: 5.0,
      image: ARTIST_2,
      collection: "Abstract",
    },
    {
      id: 4,
      title: "Neon Punk Chick",
      artist: "Nathan J",
      price: 350,
      currency: "£",
      rating: 5.0,
      image: ARTIST_2,
      collection: "Pop",
    },
    {
      id: 5,
      title: "Baterflys",
      artist: "Ksenija H",
      price: 800,
      currency: "$",
      rating: 5.0,
      image: ARTIST_5,
      collection: "Fantasy",
    },
    {
      id: 6,
      title: "Revival",
      artist: "Dina G",
      price: 900,
      currency: "$",
      rating: 5.0,
      image: ARTIST_5,
      collection: "Fantasy",
    },
  ];

  // Handle price range input change
  const handlePriceInputChange = (type, value) => {
    if (type === "min") {
      setMinPrice(value);
    } else {
      setMaxPrice(value);
    }
  };

  // Apply price filter
  const applyPriceFilter = () => {
    if (minPrice && maxPrice) {
      setPriceRange([parseInt(minPrice), parseInt(maxPrice)]);
      updateActiveFilters("price", `$${minPrice}-$${maxPrice}`);
    }
  };

  // Update active filters
  const updateActiveFilters = (type, value) => {
    const updatedFilters = activeFilters.filter(
      (filter) => filter.type !== type
    );
    updatedFilters.push({ type, value });
    setActiveFilters(updatedFilters);
  };

  // Remove filter
  const removeFilter = (type, value) => {
    const updatedFilters = activeFilters.filter(
      (filter) => !(filter.type === type && filter.value === value)
    );
    setActiveFilters(updatedFilters);

    // Reset the corresponding filter state
    if (type === "price") {
      setPriceRange([0, 6000]);
      setMinPrice("");
      setMaxPrice("");
    } else if (type === "collection") {
      setSelectedCollection("");
    }
  };

  // Filter artworks based on active filters
  const filteredArtworks = artworks.filter((artwork) => {
    // Filter by price range
    const priceFilter = activeFilters.find((filter) => filter.type === "price");
    const collectionFilter = activeFilters.find(
      (filter) => filter.type === "collection"
    );

    let matchesPrice = true;
    let matchesCollection = true;

    if (priceFilter && priceRange[0] !== 0 && priceRange[1] !== 0) {
      matchesPrice =
        artwork.price >= priceRange[0] && artwork.price <= priceRange[1];
    }

    if (collectionFilter && selectedCollection) {
      matchesCollection = artwork.collection === selectedCollection;
    }

    return matchesPrice && matchesCollection;
  });

  return (
    <>
      <div className={classes.app}>
        <div className={classes.container}>
          <div className={classes.sidebar}>
            <FilterSidebar
              priceRange={priceRange}
              minPrice={minPrice}
              maxPrice={maxPrice}
              selectedCollection={selectedCollection}
              selectedMedium={selectedMedium}
              searchQuery={searchQuery}
              location={location}
              onPriceInputChange={handlePriceInputChange}
              onApplyPriceFilter={applyPriceFilter}
              onCollectionChange={(collection) => {
                setSelectedCollection(collection);
                updateActiveFilters("collection", collection);
              }}
              onMediumChange={setSelectedMedium}
              onSearchChange={setSearchQuery}
              onLocationChange={setLocation}
            />
          </div>

          <main className={classes.main}>
            <header className={classes.header}>
              <h1>Original Paintings & Art</h1>
              <p>
                Where Art Finds You — Discover, Connect, and Create with Local
                Artists.
              </p>
            </header>

            {/* Active filters */}
            <div className={classes.activeFilters}>
              {activeFilters.map((filter, index) => (
                <div
                  key={index}
                  className={classes.filterTag}
                  onClick={() => removeFilter(filter.type, filter.value)}
                >
                  {filter.type === "price"
                    ? filter.value
                    : `Collection - ${filter.value}`}
                  <span className={classes.removeIcon}>×</span>
                </div>
              ))}
            </div>

            {/* Artwork grid */}
            <div className={classes.artworkGrid}>
              {filteredArtworks.map((artwork) => (
                <ArtworkCard key={artwork.id} artwork={artwork} />
              ))}
            </div>

            {/* Browse artists call to action */}
            <div className={classes.browseArtists}>
              <h2>Browse artists near you</h2>
              <p>and send a message to get your project started.</p>
              <button className={classes.browseArtistBtn}>Browse Artist</button>
            </div>
          </main>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ANDMarketPlace;
